import { Component, inject } from '@angular/core';
import { PasButtonRoundColor, PasButtonRoundComponent } from '@porsche-aftersales/frontend-toolbox';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { isViewable } from '../../../services/after-sales/after-sales-functions';
import { UserService } from '../../../services/user-service/user.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'after-sales-button-cell-renderer',
  templateUrl: './after-sales-button-cell-renderer.component.html',
  imports: [PasButtonRoundComponent],
})
export class AfterSalesButtonCellRenderer implements ICellRendererAngularComp {
  private readonly userService = inject(UserService);

  public params: any;

  // Receiving data from the selected row
  public agInit(params: any): void {
    this.params = params;
  }

  public onClick($event: Event): void {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onClick(params);
    }
  }

  public isDetailsViewAvailable(): boolean {
    return isViewable(this.userService.getUser(), false);
  }

  public refresh(): boolean {
    return false;
  }

  public readonly pasButtonRoundColor = PasButtonRoundColor;
}
